import block from './block.json';

export const subsectionBigTextImagesThemeAttributes = {
	introduction: {
		color: '@tokens.variants.default.contentColor',
		typography: '@tokens.typographies.heading-6',
		textAlignment: 'left',
	},
};

export const SubsectionBigTextImagesThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: subsectionBigTextImagesThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
